var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_div"},[_c('div',{staticClass:"title"},[_vm._t("back"),_vm._t("title")],2),_c('div',{staticClass:"cancel"},[_vm._t("cancel")],2),_c('div',{staticClass:"create"},[_vm._t("create")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }